<app-operations-shell area="workers" [bare]="router.url.startsWith('/workers/login') || router.url.includes('/workers/tables/')">
  <router-outlet></router-outlet>
</app-operations-shell>
